<!-- RECOMMENDED PLANS TOPPER -->

@switch (plan?.attributes?.PLAN_ID) {
  @case (recommendedPlanIds.recommendedPlan) {
    <div class="recommendedPlan">
      {{ recommendedPlanLabelOne || 'Option 1' }}
    </div>
  }
  @case (recommendedPlanIds.alternate1) {
    <div class="alternatePlan1">
      {{ recommendedPlanLabelTwo || 'Option 2' }}
    </div>
  }
  @case (recommendedPlanIds.alternate2) {
    <div class="alternatePlan2">
      {{ recommendedPlanLabelThree || 'Option 3' }}
    </div>
  }
  <!--
  There's probably a cleaner way of doing this, but for the sake of having this topper separate from the
  card, as well as not having the elevated background bleed through, and for the sake of quick consistency,
  this should resolve some margining oddities
  -->
  @default {
    <div style="visibility: hidden">
      <span>filler</span>
    </div>
  }
}

<div class="plan-card mat-typography mat-body mat-app-background">

  <!-- PLAN CARD MAIN-->
  <article class="plan-card-content">

    <!-- COMPARE PLANS - checkboxes -->
    <section class="compare-plan-section">
      @if (canDisableEnroll()) {
        <mat-checkbox id="{{ plan?.attributes?.PLAN_ID }}" class="compare-plan-checkbox"
          [ngClass]="{'hide-me': hideComparePlansCheckbox()}" #checkbox
          (change)="emitChecked($event, plan.attributes.PLAN_ID)">
          COMPARE PLAN
        </mat-checkbox>
      }
      @if (fullStarsArray.length > 0) {
        <div class="star-icon" matTooltip="{{starsTooltip}}">
          @for (s of fullStarsArray; track $index) {
            <span>
              <span class="material-symbols-outlined" style="color: #FFF689; font-size: 20px;" aria-hidden="false" aria-label="star home icon">star
              </span>
            </span>
          }
          @if (hasHalfStar) {
            <span>
              <span class="material-symbols-outlined" style="color: #FFF689; font-size: 20px;" aria-hidden="false" aria-label="star home icon">star_half
              </span>
            </span>
          }
        </div>
      }

    </section>

    @if (!disableCoverageDetails) {
      <app-plan-card-coverage-details
        [addMedicationsUrl]="addMedicationsUrl"
        [plan]="plan">
      </app-plan-card-coverage-details>
    }

    <div class="main-data-wrapper">

      <!-- PLAN CARD HEADER -->
      <section class="plan-header">
        <h2>{{ plan?.attributes?.PRODUCT_NAME }}</h2>
      </section>

      @if ((planCardImageUrl || planCardImageLabel) && planCardImageRegex?.test(plan?.attributes?.PRODUCT_NAME?.toLowerCase())) {
        <div class="plan-card-image-content">
          @if (planCardImageUrl) {
            <img class="plan-card-image" [src]="planCardImageUrl" />
          }
          @if (planCardImageLabel) {
            <div class="plan-card-image-label" [innerHTML]="planCardImageLabel"></div>
          }
        </div>
      }

      <!-- Priemium BuyBack Info -->
      @for (pricingTile of plan.summaryView?.benefits; track trackByIndex($index, pricingTile)) {
        <div class="benefit-row">
          @if (pricingTile.key ==='Part B Premium Giveback' && pricingTile.value !== 'N/A') {
            <section class="premium-buyback"
              >
              <!-- PREMIUM $$$ -->
              <div class="benefit-row">
                <div class="key">
                  Includes Part B Premium Give Back
                </div>
                <!-- BUYBACK TOOLTIP -->
                <div class="premium-tooltip"
                  matTooltip="The Part B give back benefit reduces the amount of the Medicare Part B premium. The Part B give back will be credited monthly to your Social Security check, if you pay your Part B premium through Social Security; if you don’t, you’ll pay the reduced amount directly to Medicare">
                  <span class="material-symbols-outlined">info</span>
                </div>
              </div>
            </section>
          }
        </div>
      }

      <!-- METAL LEVEL   -->
      @if (plan?.attributes?.METAL_LEVEL) {
        <section class="metal-levels">
          <div class="metal-level-dot">
            @switch (plan?.attributes?.METAL_LEVEL) {
              @case ('PLATINUM') {
                <span class="metal-icon platinum"></span>
                <h3>Platinum Tier</h3>
              }
              @case ('GOLD') {
                <span class="metal-icon gold"></span>
                <h3>Gold Tier</h3>
              }
              @case ('SILVER') {
                <span class="metal-icon silver"></span>
                <h3>Silver Tier</h3>
              }
              @case ('BRONZE') {
                <span class="metal-icon bronze"></span>
                <h3>Bronze Tier</h3>
              }
              @case ('CATASTROPHIC') {
                <span class="metal-icon catastrophic"></span>
                <h3>Catastrophic Tier</h3>
              }
            }
          </div>
        </section>
      }

      <!-- PREMIUM INFO-->
      <section class="monthly-premium">

        <!-- PREMIUM $$$ (with APTC modifier) -->
        @if (selectedAptc && selectedAptc !== 0) {
          <div class="benefit-row">
            <div class="premium-label">
              <h3>Monthly Premium After Elected Tax Credit Applied</h3>
            </div>
            <div class="premium-value">
              @if (plan?.attributes.METAL_LEVEL !== 'CATASTROPHIC') {
                <h3>
                  {{monthlyPremiumWithAPTCModifier}}
                </h3>
              } @else {
                <p>Tax credit cannot be applied to this plan</p>
                <h3>
                  {{getMonthlyPremium(plan?.price, plan.allowEnroll)}}
                </h3>
              }
              <!-- PREMIUM TOOLTIP -->
              @if (!plan?.price) {
                <div class="premium-tooltip" matTooltip="{{priceTooltip}}">
                  <span class="material-symbols-outlined">info</span>
                </div>
              }
            </div>
          </div>
        } @else {
          <!-- PREMIUM $$ -->
          <div class="benefit-row">
            <div class="premium-label">
              <h3>Monthly Premium</h3>
            </div>
            <div class="premium-value">
              <h3>
                {{getMonthlyPremium(plan?.price, plan.allowEnroll)}}
              </h3>
              <!-- PREMIUM TOOLTIP -->
              @if (!plan?.price) {
                <div class="premium-tooltip" matTooltip="{{priceTooltip}}">
                  <span class="material-symbols-outlined">info</span>
                </div>
              }
            </div>
          </div>
        }
      </section>

      <!-- SUMMARY VIEW -->
      <section class="summary-view">

        <!-- SUMMARY VIEW ITEMS-->
        @if (plan.summaryView) {
          @for (pricingTile of plan.summaryView?.benefits; track trackByIndex($index, pricingTile)) {
            <div class="benefit-row">
              <div class="key">
                {{pricingTile.key}}
              </div>
              <div matTooltip="{{pricingTile.tooltipValue}}" class="value">
                {{ pricingTile.displayValue }}
              </div>
            </div>
          }
        }


      </section>

      <!-- INDICATOR ICONS -->
      <section class="indicator-icons">
        <app-indicator-icons [plan]="plan"></app-indicator-icons>
      </section>

      <!-- DETAIL/ENROLL BUTTONS -->
      <section class="buttons">

        @if (plan.allowEnroll) {
          <ng-container #planDetailsButton>
            <a href="javascript:void(0)" color="primary" class="plan-details-button"
              id="details-plan-{{this.productName}}"
              [ngClass]="{'hide-me-but-dont-forgot-me': hidePlanDetailsInteraction()}" (click)="goToPlanDetails()">
              DETAILS
            </a>
          </ng-container>
        } @else {
          <a href="javascript:void(0)" color="primary" class="plan-details-button need-more-details-button"
            [ngClass]="{'hide-me-but-dont-forgot-me': hidePlanDetailsInteraction()}" (click)="emitShowForm()">
            For accurate cost, eligibility, and to compare plans we need your details
          </a>
        }


        <app-enroll-button [allowEnroll]="plan.allowEnroll" [enrollStartUrl]="enrollStartUrl"
          [specialEnrollmentUrl]="specialEnrollmentUrl" [plan]="plan" [isSep]="isSep">
        </app-enroll-button>

      </section>

    </div>

  </article>

</div>
